import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Rooms', href: '#rooms' },
  { label: 'Gardens', href: '#gardens' },
  { label: 'Amenities', href: '#amenities' },
  { label: 'Awards', href: '#awards' },
  { label: 'Documents', href: '#documents' },
  { label: "Seller's Note", href: '#honest-circumstances' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-sm border-b border-cream-dark'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-12 py-6">
        {/* Logo */}
        <a
          href="#"
          onClick={e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
          className="flex items-center cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/a853a7261abdde22808a704dea326f3c/12cc32943ef87388ca463c82041471e1.jpeg"
            alt="Montebrisa Boutique B&B Logo"
            className="h-9 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map(link => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className={`text-sm font-sans tracking-widest uppercase transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-forest hover:text-gold' : 'text-white hover:text-gold-light'
              }`}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick('#contact')}
            className={`px-5 py-2 text-sm font-sans tracking-widest uppercase rounded-md border transition-all duration-300 cursor-pointer whitespace-nowrap ${
              scrolled
                ? 'border-gold text-gold hover:bg-gold hover:text-white'
                : 'border-white/80 text-white hover:bg-white hover:text-forest'
            }`}
          >
            Inquire
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled ? 'text-forest' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-cream-dark px-6 py-4 flex flex-col gap-4">
          {NAV_LINKS.map(link => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="text-sm font-sans tracking-widest uppercase text-forest hover:text-gold text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick('#contact')}
            className="mt-2 px-5 py-2 text-sm font-sans tracking-widest uppercase rounded-md border border-gold text-gold hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap self-start"
          >
            Inquire
          </button>
        </div>
      )}
    </header>
  );
}
